module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_5012.39b89c00.png";